import routersAll from "./routersAll";
import navigation from "@/page/vibrantRubikCube/runtime/navigation";
import customForm from "@/page/vibrantRubikCube/runtime/customForm";
import submittedForm from "@/page/vibrantRubikCube/runtime/submittedForm";
import awardRotate from "@/page/vibrantRubikCube/runtime/awardRotate";
import hdmain from "@/page/vibrantRubikCube/runtime/hdmain";
import GroupEntryQRCode from "@/page/vibrantRubikCube/groupEntryQRCode/GroupEntryQRCode";
import StoreQRCode from "@/page/vibrantRubikCube/storeEntryGroup/storeQrCode";
import activityCenter from "../page/vibrantRubikCube/activityCenter/index.vue";
import activateCard from "@/page/vibrantRubikCube/runtime/activateCard";
import winnerList from "@/page/vibrantRubikCube/runtime/winnerList";
import offinterestCoupon from "@/page/vibrantRubikCube/runtime/themaicComponent/offinterest-coupon";
import beneficialProducts from "@/page/vibrantRubikCube/runtime/themaicComponent/beneficial-products";
import equityPackage from "@/page/vibrantRubikCube/runtime/themaicComponent/equity-package";
import privateText from "@/page/vibrantRubikCube/runtime/privateText";
import npsForm from "@/page/vibrantRubikCube/runtime/nps-form";
import npsFormSubmited from "@/page/vibrantRubikCube/runtime/nps-form-submited";
import signIn from "@/page/vibrantRubikCube/runtime/sign-in";
import signInRules from "@/page/vibrantRubikCube/runtime/sign-in-rules";
import middleMessagePage from "@/page/vibrantRubikCube/middleMessagePage/middleMessagePage";
import paymentRedirectPage from "@/page/vibrantRubikCube/paymentRedirectPage/payment-redirect-page.vue";
import sharePoster from "@/page/vibrantRubikCube/runtime/interest-form/components/share-poster"; // 趣味表单海报分享
import scanGameWallLocate from "@/page/vibrantRubikCube/scanGameWallLocate/scanGameWallLocate"; // 游戏墙-扫码后门店定位和DP拉起
import activityBoostPage from "@/page/vibrantRubikCube/runtime/activity-boost/activity-boost-page.vue";
import activityBoostDetail from "@/page/vibrantRubikCube/runtime/activity-boost/activity-boost-detail.vue";
//components 命名视图
export default [
  {
    path: "",
    components: routersAll
  },
  {
    path: "/",
    components: routersAll
  },
  {
    path: "/navigation",
    name: "navigation",
    meta: {
      isNotPerm: true
    },
    component: navigation,
    beforeEnter: (to, from, next) => {
      document.getElementById("myTitle").innerHTML = "荣耀门店导航";
      next();
    }
  },
  {
    path: "/customForm",
    name: "customForm",
    meta: {
      isNotPerm: true
    },
    component: customForm
  },
  {
    path: "/submittedForm",
    name: "submittedForm",
    meta: {
      isNotPerm: true
    },
    component: submittedForm
  },
  {
    path: "/npsForm",
    name: "npsForm",
    meta: {
      isNotPerm: true
    },
    component: npsForm
  },
  {
    path: "/npsFormSubmited",
    name: "npsFormSubmited",
    meta: {
      isNotPerm: true
    },
    component: npsFormSubmited
  },
  {
    path: "/signIn",
    name: "signIn",
    meta: {
      isNotPerm: true
    },
    component: signIn
  },
  {
    path: "/signInRules",
    name: "signInRules",
    meta: {
      isNotPerm: true
    },
    component: signInRules
  },
  {
    path: "/awardRotate",
    name: "awardRotate",
    meta: {
      isNotPerm: true
    },
    component: awardRotate
  },
  {
    path: "/winnerList",
    name: "winnerList",
    meta: {
      isNotPerm: true
    },
    component: winnerList
  },
  {
    path: "/offinterestCoupon",
    name: "offinterestCoupon",
    meta: {
      isNotPerm: true
    },
    component: offinterestCoupon
  },

  {
    path: "/beneficialProducts",
    name: "beneficialProducts",
    meta: {
      isNotPerm: true
    },
    component: beneficialProducts
  },
  {
    path: "/equityPackage",
    name: "equityPackage",
    meta: {
      isNotPerm: true
    },
    component: equityPackage
  },
  {
    // 转盘抽奖活动主页
    path: "/hdmain",
    name: "hdmain",
    meta: {
      isNotPerm: true
    },
    component: hdmain
  },
  {
    // 入群二维码
    path: "/groupEntryQRCode",
    name: "groupEntryQRCode",
    meta: {
      isNotPerm: true
    },
    component: GroupEntryQRCode
  },
  {
    // 门店入群二维码
    path: "/storeQRCode",
    name: "storeQRCode",
    meta: {
      isNotPerm: true
    },
    component: StoreQRCode
  },
  {
    // 活动中心
    path: "/activityCenter",
    name: "activityCenter",
    meta: {
      isNotPerm: true
    },
    component: activityCenter
  },
  {
    path: "/noPermission",
    name: "noPermission",
    components: routersAll
  },
  {
    path: "/vibrantRubikCube/customForm/list",
    components: routersAll //活力魔方 => 自定义表单
  },
  {
    path: "/activateCard",
    name: "activateCard",
    meta: {
      isNotPerm: true
    },
    component: activateCard
  },
  {
    path: "/privateText",
    name: "privateText",
    meta: {
      isNotPerm: true
    },
    component: privateText
  },
  {
    path: "/sharePoster",
    name: "sharePoster",
    meta: {
      isNotPerm: true
    },
    component: sharePoster
  },
  {
    // 短信中间跳转页
    path: "/middleMessagePage",
    name: "middleMessagePage",
    meta: {
      isNotPerm: true
    },
    component: middleMessagePage
  },
  {
    path: "/scanGameWallLocate",
    name: "scanGameWallLocate",
    meta: {
      isNotPerm: true
    },
    component: scanGameWallLocate
  },
  {
    // 小程序支付跳转页
    path: "/paymentRedirectPage",
    name: "paymentRedirectPage",
    meta: {
      isNotPerm: true
    },
    component: paymentRedirectPage
  },
  {
    // 活动助力页
    path: "/activityBoostPage",
    name: "activityBoostPage",
    meta: {
      isNotPerm: true
    },
    component: activityBoostPage
  },
  {
    // 活动邀请明细页
    path: "/activityBoostDetail",
    name: "activityBoostDetail",
    meta: {
      isNotPerm: true
    },
    component: activityBoostDetail
  }
];



// WEBPACK FOOTER //
// ./src/router/routers.js